import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Button": Button, "@mui/material/ButtonGroup": ButtonGroup, "@mui/icons-material/ArrowDropDown": ArrowDropDownIcon, "@mui/material/ClickAwayListener": ClickAwayListener, "@mui/material/Grow": Grow, "@mui/material/Paper": Paper, "@mui/material/Popper": Popper, "@mui/material/MenuItem": MenuItem, "@mui/material/MenuList": MenuList } } });
export default ClientProvider;
